<template>
  <div>
    <d-header
      fluid
      :actions="[{
        label: $t('save'),
        primary: true,
        color: 'is-primary',
        action: submitForm
      }]"
      :breadcrumbs="false"
    >
      <h1 class="title">
        <d-previous-btn
          :path="'/properties/' + $route.params.property + '/property-inspections'"
        />
        {{ $t('new_property_inspection') }}
      </h1>
    </d-header>

    <v-form
      ref="form"
      action="create"
      :property-id="model.id"
    />
  </div>
</template>

<script>
import form from "./_form.vue";
export default {
  metaInfo() {
    return {
      title: this.$t("new_property_inspection")
    };
  },
  components: {
    "v-form": form
  },
  props: {
    model: {
      default: null,
      type: Object
    }
  },
  methods: {
    submitForm () {
      this.$refs.form.$refs.form.submit();
    }
  }
};
</script>
